import React from "react";

export function Logo() {
  return (
    <div id="logo" role="img" aria-label={I18N("Logo")}>
      {!Commons.isEmpty(APP.settings.tenant?.Logo) && (
        <a
          href={
            !Commons.isEmpty(APP.settings.tenant?.LogoLink)
              ? APP.settings.tenant?.LogoLink
              : APP.settings.homeUrl
          }
          aria-label={I18N("Zur Startseite")}
        >
          <img
            id="header-logo-img"
            alt={I18N("TraumGarten Logo")}
            src={APP.settings.wkfgContentBaseUrl + "MassTenant/" + APP.settings.tenant?.Logo}
          />
        </a>
      )}
    </div>
  );
}
